import { SectionHeading } from "@/components/shared/SectionHeading";
import { Reveal, RevealStagger, RevealItem } from "@/components/shared/Reveal";

const SCENARIOS = [
  "A commercial driver reaches an Hours of Service limitation.",
  "An owner operator becomes sick or has an emergency.",
  "A carrier needs a replacement driver.",
  "A driver becomes fatigued and should not continue.",
  "A scheduled relay needs another qualified driver.",
  "An RV owner needs a motorhome recovered.",
  "An RV dealer needs a vehicle delivered to a customer.",
  "A fleet needs a vehicle repositioned.",
];

export const Problem = () => {
  return (
    <section data-testid="problem-section" className="py-24 md:py-32 bg-rr-navy relative overflow-hidden">
      <div className="grain-overlay" />
      <div className="max-w-7xl mx-auto px-5 md:px-8 grid lg:grid-cols-[1fr_1fr] gap-16">
        <div>
          <SectionHeading
            eyebrow="The Problem RelayRigs Solves"
            title="A Truck Can Still Move Even When the Original Driver Can't."
            light
            testId="problem"
          />
          <Reveal delay={0.3}>
            <p className="mt-8 text-white/60 text-base leading-relaxed max-w-md">
              Traditional transportation systems often treat these as separate problems. RelayRigs creates a marketplace and operational system around finding the appropriate driver and documenting the assignment.
            </p>
          </Reveal>
        </div>
        <RevealStagger className="grid sm:grid-cols-2 gap-4">
          {SCENARIOS.map((s, i) => (
            <RevealItem key={s}>
              <div data-testid={`problem-scenario-${i}`} className="border border-white/10 rounded-xl p-5 h-full bg-white/[0.03] hover:border-rr-orange/40 transition-colors">
                <span className="text-rr-orange font-heading font-bold text-sm">{String(i + 1).padStart(2, "0")}</span>
                <p className="text-white/80 text-sm mt-2 leading-relaxed">{s}</p>
              </div>
            </RevealItem>
          ))}
        </RevealStagger>
      </div>
    </section>
  );
};
